<template>
  <div>
    <Row class="detail-header">
      <span>{{ $t('TestShop') }}</span>
    </Row>
    <Row v-if="defaultData" class="detail-content">
      <Row>
        <Col span="5" class="left-label">{{ $t('TestShopImage') }}：</Col>
        <Col span="16" class="right-content">
          <file-upload
            :default-list="defaultList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">{{ $t('Remarks') }}：</Col>
        <Col span="16" class="right-content">{{ defaultData.remark }}</Col>
      </Row>
      <Row>
        <Col span="5" class="left-label">{{ $t('sendSamples') }}：</Col>
        <Col span="16" class="right-content">{{ defaultData.isMail?$t('Yes'):$t('No') }}</Col>
      </Row>
      <Row v-if="defaultData.isMail">
        <Row>
          <Col span="5" class="left-label">{{ $t('courierCompany') }}：</Col>
          <Col span="16" class="right-content">{{ defaultData.companyName }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">{{ $t('trackingNumber') }}：</Col>
          <Col span="16" class="right-content">
            <a href="javascript:void(0);" @click="logisticsCtrl=true;">{{ defaultData.expressNo }}</a>
          </Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">{{ $t('senderName') }}：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderName }}</Col>
        </Row>
        <Row />
        <Row>
          <Col span="5" class="left-label">{{ $t('sender') }}{{ $t('Mobile') }}：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderMobile }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">{{ $t('senderRegion') }}：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderProvinceName+defaultData.senderCityName+defaultData.senderAreaName }}</Col>
        </Row>
        <Row>
          <Col span="5" class="left-label">{{ $t('senderFullAddress') }}：</Col>
          <Col span="16" class="right-content">{{ defaultData.senderAddress }}</Col>
        </Row>
      </Row>

      <!-- <Row v-if="defaultData.isSample">
                <Row><Col span="5" class="left-label">邮寄地址：</Col><Col span="16" class="right-content">{{defaultData.address}}</Col></Row>
                <Row><Col span="5" class="left-label">样品名称：</Col><Col span="16" class="right-content">{{defaultData.sampleName}}</Col></Row>
                <Row><Col span="5" class="left-label">样品数量：</Col><Col span="16" class="right-content">{{defaultData.sampleNumber}}</Col></Row>
                <Row><Col span="5" class="left-label">邮寄公司：</Col><Col span="16" class="right-content">{{defaultData.companyName}}</Col></Row>
                <Row>
                    <Col span="5" class="left-label">邮寄单号：</Col>
                    <Col span="16" class="right-content">
                        <a href="javascript:void(0);" @click="logisticsCtrl=true;">{{defaultData.expressNo}}</a>
                    </Col>
                </Row>
            </Row> -->
      <!-- <Row>
                <Col span="5" class="left-label">测购意见：</Col>
                <Col span="16" class="right-content">
                    <Row v-if="isInfo">{{defaultData.customerOpinion==null?"":(defaultData.customerOpinion?"同意打击":"不同意打击")}}</Row>
                    <RadioGroup v-model="formData.customerOpinion" v-else>
                        <Radio :label="1">同意打击</Radio>
                        <Radio :label="0">不同意打击</Radio>
                    </RadioGroup>
                </Col>
            </Row> -->
      <!-- <Row class="detail-btn-box">
                <Button type="primary" v-if="defaultData.state=='P'&&!isInfo" :disabled="isSumbit" @click="sumbitData">{{ $t('Save') }}</Button>
                <Button v-if="defaultData.state=='P'&&isInfo" @click="isInfo=false">修改</Button>
            </Row> -->
    </Row>
    <Row v-if="!defaultData" class="no-tips">{{ $t('NoTestShop') }}</Row>

    <!-- 物流信息 -->
    <Modal
      v-model="logisticsCtrl"
      :title="$t('TrackingNumber')+defaultData.expressNo"
      width="550"
      :footer-hide="true"
    >
      <logistics-information v-if="logisticsCtrl" :express-no="defaultData.expressNo" :company="defaultData.company" />
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['clueDetail'],
  data () {
    return {
      projectConfigInfo: '',
      defaultList: [],
      isSumbit: false,
      logisticsCtrl: false,
      formData: {
        customerOpinion: 1
      },
      defaultData: '',
      isInfo: true
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    // this.getProjectConfig()
    this.getDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    getDetail() {
      const url = `/business/clue/trial-order/info/${this.clueDetail.id}`
      this.$get(url).then(res => {
        this.defaultData = res.data || ''
        if (res.data) {
          this.giveDefaultData()
        }
      })
    },
    /* getProjectConfig() {
      const url = `/business/test-purchase-config/${this.clueDetail.projectId}`
      this.$get(url).then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.projectConfigInfo = res.data
            this.formData.address = res.data.address
            this.formData.isSample = res.data.isMailingSample ? 1 : 0
            this.getDetail()
          }
        }
      })
    }, */
    giveDefaultData() {
      this.formData.address = this.defaultData.address
      this.formData.mgmtRemark = this.defaultData.mgmtRemark
      this.formData.customerOpinion = (this.defaultData.customerOpinion == null || this.defaultData.customerOpinion) ? 1 : 0
      this.formData.isSample = this.defaultData.isSample ? 1 : 0
      this.defaultList = []
      this.defaultData.attachmentList.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.defaultList.push(obj)
      })
      this.isInfo = true
    },
    sumbitData() {
      const url = '/business/clueTestPurchase/test-purchase'
      const ajaxData = {
        clueId: this.clueDetail.id,
        id: this.defaultData.id,
        attachmentList: this.defaultList
      }
      Object.assign(ajaxData, this.formData)
      this.isSumbit = true
      this.$patch(url, ajaxData).then(res => {
        this.isSumbit = false
        if (res.code == 0) {
          this.$Message.success(this.$t('OperationSuccessful'))
          this.getDetail()
        } else {
          this.$Message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.no-tips{
    padding: 10px 10px 10px 30px;
    font-size: 14px;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/view/clue/plugin/testPurchaseForm.vue